import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface TestBannerProps {
  className?: string;
  children?: React.ReactNode;
}

export function TestBanner({ className, children }: TestBannerProps) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-md bg-amber-50 text-amber-700 dark:bg-amber-950/30 dark:text-amber-400 border border-amber-200 dark:border-amber-800/50 text-[10px] font-medium uppercase tracking-wide",
        className
      )}
    >
      {children || t("common.test")}
    </span>
  );
}
